namespace('compass.hotel');
compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.hotel.HotelPictureSummaryTileWidget = compass.defineWidget(function HotelPictureSummaryTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";
	var _rangeFormatter = compass.util.dateFormatter('ddd, mmm d');
	var _fullDateFormatter = _settings.meetingInfo.defaultDateFormatter;
	var _nonEditable = (_settings.reservations.reservationsArray.length > 0 && !_settings.reservations.reservationsArray[0].editable) ? true : false;
    var _dialogId = compass.generateId();

    /* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		jQuery.map(_settings.reservations.reservationsArray, function(n) {
			widgetElem.append(me.drawHotelTile(n));
		});
		_setupControls();
		if(_nonEditable){
			widgetElem.addClass('nonEditable');
		}
	};

	this.drawHotelTile = function(resObj) {
		var d = _d;
		var hotelTile = d.div({className:'tileWrapper tile', tabindex: accessibilty.TAB_INDEX, 'aria-role' : 'button', role : 'button', 'aria-owns':_dialogId},
			d.div({className:'hotelImage', style :
				{ 'background-image' : 'url(' + encodeURI(resObj.hotelImage.length > 0 ? resObj.hotelImage : _defaultImage) + ')' } }),
			me.drawHotelStayInfo(resObj)
		);
		// only allow keyboard input/clicks if the hotel is editable
		if(!_nonEditable){
			hotelTile.activate(
				// create a new object with all the info from resObj (which remains untouched), and ad an HTML id to it
				function () { me.trigger('HotelPictureSummaryTileWidget.viewDetails', jQuery.extend({}, resObj, { id: _dialogId })); }
			);
		}
		return hotelTile;
	};

	this.drawHotelStayInfo = function(hotelInfoObj) {
		var d = _d;
		var linkText = 'View details, make changes or cancel <abbr alt="">&raquo;</abbr>';
		var linkTag = 'normal';
		if(!hotelInfoObj.editable){
			linkText = 'Alterations to this reservation are not allowed';
			linkTag = 'uneditable';
		}
		/*we show the cutoff message if the hotel is paused no matter what */
		if(hotelInfoObj.paused || (hotelInfoObj.cut_off && !hotelInfoObj.cancel_and_replace)){
			linkText = 'This hotel is cut-off. Reservations cannot be edited.';
			linkTag = 'cutoff';
		}
		var linkToRes = d.div({className:'linkToRes'},
			d.div({
				className : 'linkCopy' + ' ' + linkTag,
				role : 'link',
				'ARIA-role' : 'link',
				tabindex : 0
			}, linkText)
		);

		var stayRange = _formatStayRange(hotelInfoObj.arrive, hotelInfoObj.depart);

		var roomTypeCharLength = 65;
		var roomType = hotelInfoObj.roomType.length > roomTypeCharLength ? $j.trim(hotelInfoObj.roomType.substring(0,roomTypeCharLength-3)) + '...' : hotelInfoObj.roomType;
		return d.div({className:'hotelStayInfo'},
					d.div({className:'hotelInfo'},
						d.div({className:'hotelName'}, hotelInfoObj.hotelName + (hotelInfoObj.GDS ? ' (Web Rate Hotel)' : '')),
						d.div({className: 'stayDetails roomTypeName'}, roomType),
						d.div({className: 'stayDetails'},
							hotelInfoObj.numberOfRooms + ' Room' + (hotelInfoObj.numberOfRooms > 1 ? 's' : '') + ' (',
							stayRange,
							')'
						)
					),
					linkToRes,
					d.div({className:'endHotelStayInfo'})
				);
	};

	// make the screen readers read out 'March twenty two through March twenty three'
	// output of code is as follows:
	// <abbr title="Saturday, March 22">Sat, Mar 22</abbr>
	// <abbr title="through"> - </abbr>
	// <abbr title="Sunday, March 23">Sun, Mar 23</abbr>
	function _formatStayRange(arrive, depart) {
		var d = _d;
		var arriveDate = compass.util.parse.ISODateParser(arrive);
		var departDate = compass.util.parse.ISODateParser(depart);

		return d.span({ className : 'dateRange' },
			d.abbr({ className : 'arrive', title : _fullDateFormatter(arriveDate) }, _rangeFormatter(arriveDate)),
			d.abbr({ title : 'through' }, ' - '),
			d.abbr({ className : 'depart', title : _fullDateFormatter(departDate) }, _rangeFormatter(departDate))
		);
	}

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultHotelPictureSummaryTileWidgetWUID',
	widgetName : 'HotelPictureSummaryTileWidget',
	imgPath : '/resources/img',
	subclass : false,
	meetingInfo : { },
	reservationsArray : []
});
